export default {
  bad_request: 'Solicitud erronea. Por favor, recargue la página y vuelva a internalo.',
  forgot_password: '¿Olvidó su contraseña?',
  form_description: 'Bienvenido! Por favor, introduzca sus datos',
  form_description_username: 'Digite la contraseña para {{username}}',
  form_title: 'Iniciar sesión',
  invalid_user_credentials: 'Credendiales de usuario inválidas',
  locked: 'Su usuario ha sido bloqueado temporalmente. Por favor intente de nuevo más tarde.',
  not_you: '(¿No eres tú?)',
  page_title: '{{realmName}} - Iniciar sesión',
  register: 'Crear una cuenta',
  register_label: '¿No tienes una cuenta?',
  remember_me: 'Recordarme por 90 días',
  sign_in_with_passkey_error: 'Nombre de usuario o contraseña incorrectos. Inténtalo de nuevo o haz clic en Olvidé la contraseña para restablecerla.',
  sing_in: 'Iniciar sesión',
  sing_in_error: 'Nombre de usuario o contraseña incorrectos. Inténtalo de nuevo o haz clic en Olvidé la contraseña para restablecerla.',
  sing_in_with_passkey: 'Iniciar sesión',
  success_description: 'Te estamos redirigiendo a la aplicación.',
  success_title: 'Sesión iniciada satisfactoriamente!',
  user_is_locked: 'Usuario bloqueado',
  user_not_found: 'Usuario no encontrado',
};